(function (TeamAPI) {

    "use strict";
    angular.module("harriApp")
        .directive('employeeContactInfo', ['$filter', '$rootScope', "TeamCommunicationService", "TeamScheduleService", "EditContactInfoForm", "Upload", "TSUsersService", "hUser", function ($filter, $rootScope, TeamCommunicationService, TeamScheduleService, EditContactInfoForm, Upload, TSUsersService, hUser) {
            return {
                restrict: "E",
                replace: 'true',
                scope: {
                    brandId: '=',
                    member: '='
                },
                templateUrl: '../modules/team_schedule/employer/contact-info/views/employee_contact_info_directive.html',
                link: function ($scope, attrs) {
                    $scope.user = hUser;
                    $scope.loading = false;
                    $scope.isEditing = false;
                    $scope.editForm = EditContactInfoForm($scope, hUser);
                    $scope.contactInfo = {};
                    $scope.counter = 0;
                    $scope.ssnAction = "reveal";
                    $scope.ssnStatus = "HIDDEN";

                    $scope.toggleSSNStatus= function() {
                        if ($scope.ssnStatus == "HIDDEN") {
                            $scope.ssnAction = "hide";
                            $scope.ssnStatus = "REVEALED";
                        } else {
                            $scope.ssnAction = "reveal";
                            $scope.ssnStatus = "HIDDEN";
                        }
                    }
                    $scope.formatSSN = function(ssn) {
                        if (ssn) {
                            if ($scope.ssnStatus == "HIDDEN") {
                                return ssn.slice(0, 3)+"-"+ ssn.slice(3, 5)+"-"+ "\u2022\u2022\u2022\u2022";
                            } else {
                                return ssn.slice(0, 3)+"-"+ ssn.slice(3, 5)+"-"+ssn.slice(5, 9);
                            }
                        }
                        return "";
                    };

                    var _tcService = new TeamCommunicationService();

                    $scope.showAuditLog = function() {
                        if ($scope.isADPPayrollSyncEligable()) {
                            $scope.isLoadingHistory = true;
                            _tcService.showAuditLog($scope.activeBrand, $scope.member).then(
                                function(logEntries) {
                                    $scope.isLoadingHistory = false;
                                    $scope.logEnteries = logEntries;
                                    setTimeout(function(){
                                        $scope.$digest();
                                    },1)
                                },
                                function (err){
                                    $scope.isLoadingHistory = false;
                                }
                            )
                        }
                    }

                    $scope.isClockTimeEnabled = TeamScheduleService.isClockTimeAppEnabled();
                    $scope.isMemberEmployee = $scope.member && $scope.member.types &&
                        ($scope.member.types.indexOf("EMPLOYEE") > -1 && $scope.member.types.indexOf("EMPLOYER") < 0);

                    TeamScheduleService.getActiveBrand()
                        .then(function (brand) {
                            $scope.activeBrand = brand;
                            $scope.nevadaOTSettingEnabled = $scope.activeBrand.is_health_insurance_offeree_enabled;
                            $scope.isADPPayrollSyncEligable = function(){
                                return ($scope.activeBrand.payroll_type == "ADP" && TeamScheduleService.isPaySheetAdmin() && hUser.isPayrollSyncEnabled() && $scope.member && $scope.member.is_sent_to_payroll);
                            }
                        });

                    /**
                     * Show member contact info data
                     */
                    $scope.showContactInfo = function () {
                        $scope.isContactInfoShown = true;
                        TeamAPI.getMemberContactInfo($scope.brandId, $scope.member.id)
                            .then(function (contactInfo) {

                                $scope.contactInfo = contactInfo;

                                if (_.isEmpty($scope.contactInfo['location'])) {
                                    delete $scope.contactInfo['location']
                                } else {
                                    if (!$scope.contactInfo['location'].result) {
                                        $scope.contactInfo['location'] = {result: $scope.contactInfo['location']};
                                    }
                                }

                                $scope.originalContactInfo = angular.copy($scope.contactInfo);
                                $scope.$digest();
                            }, function (error) {
                                $scope.isContactInfoShown = false;
                                console.error(error);
                                hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong"));
                                $scope.loading = false;
                                try {
                                    $scope.$digest();
                                } catch (e) {
                                }
                            });
                    };

                    var primaryLocation;

                    $scope.getEmployeeActiveLocations = function (groupId, userId) {
                        TeamAPI.getEmployeeActiveLocations(groupId, userId)
                            .then(function (locations) {

                                $scope.activeLocations = locations.brands;
                                $scope.originalLocations = angular.copy(locations.brands);
                                primaryLocation = _.findWhere(locations.brands, {is_primary: true});

                                $scope.isActiveBrandMemberPrimary = locations.brands &&
                                                                    locations.brands.length &&
                                                                    primaryLocation &&
                                                                    primaryLocation.id === $scope.activeBrand.id;

                                TeamAPI.getEmployeeUnassignedLocations(groupId, userId)
                                    .then(function (unassignedLocations) {
                                        $scope.unassignedLocations = unassignedLocations.brands;
                                        $scope.$digest();
                                    }, function (err) {
                                        console.error(err);
                                    });
                            }, function (err) {
                                console.error(err);
                                if (err.status === 422) {
                                    $scope.noActiveBrands = true;
                                } else {
                                    hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong"));
                                }
                                $scope.$digest();
                            });
                    };

                    $scope.showContactInfo();
                    $scope.getEmployeeActiveLocations(hUser.getUserContext().brand_id, $scope.member.id);
                    $scope.user = hUser;
                    $scope.showMemberProfile = function () {
                        _tcService.showMemberProfile($scope.brandId, $scope.member.id);
                    };

                    $scope.resendAgain = function () {
                        $scope.sendingCode = true;

                        TeamAPI.resendPINCode($scope.brandId, $scope.member.id)
                            .then(function (res) {
                                hAlert($filter("translate")("Success"), $filter("translate")("The PIN Sent Successfully"));
                            }, function (err) {
                                hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong"));
                            })
                    };

                    /**
                     * Validates and saves contact info
                     */
                    $scope.saveInfo = function () {

                        $scope.isLoading = true;

                        $scope.editForm.save()
                            .then(function (updatedData) {
                                var updatedInfo;
                                if (!$scope.isActiveBrandMemberPrimary) {
                                    updatedInfo = {
                                        is_meal_participant: updatedData['contactInfo']['is_meal_participant'],
                                        is_health_insurance_offeree: updatedData['contactInfo']['is_health_insurance_offeree']
                                    }
                                } else {
                                    updatedInfo = updatedData['contactInfo'];
                                }
                                var updatedLocations = updatedData['activeLocations'];
                                if (["ADP"].indexOf($scope.activeBrand.payroll_type) == -1) {
                                    delete updatedInfo.ssn;
                                }
                                if (!angular.equals(updatedInfo, $scope.originalContactInfo)) {
                                    TeamAPI.updateMemberContactInfo($scope.brandId, $scope.member.id, updatedInfo)
                                        .then(function () {

                                            if (!angular.equals(updatedInfo['first_name'], $scope.originalContactInfo['first_name'] ) || !angular.equals(updatedInfo['last_name'], $scope.originalContactInfo['last_name']) || !angular.equals(updatedInfo['ssn'],$scope.originalContactInfo['ssn'])) {
                                                if ($scope.isADPPayrollSyncEligable()) {
                                                    if ($scope.member['out_of_sync_sections'].indexOf(TeamAPI.PAYROLL_SYNC_TYPE.PERSONAL_INFO) == -1) {
                                                        $scope.member['out_of_sync_sections'].push(TeamAPI.PAYROLL_SYNC_TYPE.PERSONAL_INFO);
                                                    }
                                                }
                                            }
                                            $scope.contactInfo = angular.copy(updatedInfo)
                                            $scope.originalContactInfo = angular.copy(updatedInfo)


                                            for (var key in updatedInfo) {
                                                $scope.member[key] = updatedInfo[key];
                                            }
                                            TSUsersService.updateUserInfo($scope.member.id, $scope.member)
                                            updateLocations(updatedLocations).then(function(res){
                                                endEditing();
                                            }, function(err) {
                                                endEditing();
                                            })

                                        }, function (error) {
                                            console.error(error);
                                            hAlert($filter("translate")("Error"), $filter("translate")(error.data.status));
                                            endEditing();
                                        });
                                } else {
                                    updateLocations(updatedLocations).then(function(res){
                                        endEditing();
                                    }, function(err) {
                                        endEditing();
                                    })
                                }


                                if (angular.equals(updatedInfo, $scope.originalContactInfo) && angular.equals(updatedLocations, $scope.originalLocations)) {
                                    endEditing();
                                }

                            }, function () {

                                $scope.isLoading = false;
                                $scope.isContactInfoShown = false;

                                try {
                                    $scope.$digest();
                                } catch (e) {
                                }

                            });
                    };
                    var endEditing = function() {
                        $scope.isEditing = false;
                        $scope.isLoading = false;
                        $scope.$digest();
                    }
                    var updateLocations = function (updatedLocations) {
                        var defer = $q.defer();
                        if (!angular.equals(updatedLocations, $scope.originalLocations)) {
                            TeamAPI.updateEmployeeActiveLocations(hUser.getUserContext().brand_id, $scope.member.id, updatedLocations)
                                .then(function () {

                                    $scope.contactInfo['locations'] = updatedLocations;
                                    $scope.originalLocations = angular.copy(updatedLocations);

                                    var newPrimaryLocation = _.findWhere(updatedLocations, {is_primary: true});
                                    if (newPrimaryLocation['id'] !== primaryLocation['id']) {
                                        primaryLocation = newPrimaryLocation;
                                        $scope.isActiveBrandMemberPrimary = updatedLocations &&
                                            updatedLocations.length &&
                                            primaryLocation &&
                                            primaryLocation.id === $scope.activeBrand.id;
                                    }

                                    defer.resolve({});

                                }, function (error) {
                                    console.error(error);

                                    hAlert($filter("translate")("Error"), $filter("translate")(error.data.status));
                                    defer.reject({});
                                });
                        } else {
                            defer.resolve({})
                        }
                        return defer.promise;
                    }
                    var showSyncMessages =function(msg, status, timeOut) {
                        $scope.isShowingSyncMsg = true;
                        $scope.syncMsg = msg;
                        $scope.isSyncInProgress = (status == "IN-PROGRESS");
                        $scope.didSyncSucceed = (status == "SUCESSS");
                        $scope.didSyncFailed = (status == "FAIL");
                        setTimeout(function () {
                            $scope.$digest()
                        }, 1)
                        if (timeOut > 0) {
                            setTimeout(function(){
                                $scope.isShowingSyncMsg = false;
                                $scope.$digest()
                            }, timeOut*1000)
                        }
                    }

                    $scope.syncWithADP= function() {
                        hConfirm({
                            text: "Are you sure you want to sync with ADP? This will override any existing details on ADP side?",
                            confirmButton: "Okay",
                            callback: function (confirmed) {
                                if (confirmed) {
                                    showSyncMessages("Syncing Personal Info with " + $scope.activeBrand.paysheet_payroll_type, "IN-PROGRESS", -1);
                                    TeamAPI.syncWithPayroll($scope.activeBrand.id, $scope.member.id, $scope.activeBrand.paysheet_payroll_type, TeamAPI.PAYROLL_SYNC_TYPE.PERSONAL_INFO).then(
                                        function (result) {
                                            if ($scope.member['out_of_sync_sections'].indexOf(TeamAPI.PAYROLL_SYNC_TYPE.PERSONAL_INFO) != -1) {
                                                $scope.member['out_of_sync_sections'].splice($scope.member['out_of_sync_sections'].indexOf(TeamAPI.PAYROLL_SYNC_TYPE.PERSONAL_INFO), 1)
                                                TSUsersService.updateUserInfo($scope.member.id, $scope.member);
                                            }

                                            showSyncMessages("Synced Successfully with " + $scope.activeBrand.paysheet_payroll_type, "SUCESSS", 5);

                                        }, function (err) {
                                            showSyncMessages("Something went wrong while syncing the data...", "FAIL", 5);
                                            ;
                                        }
                                    )
                                }
                            }
                        });

                    }

                    $scope.editInfo = function (addNewLocation) {
                        $scope.isLoading = true;
                        $scope.editForm.load($scope.contactInfo, $scope.activeLocations, addNewLocation, $scope.isActiveBrandMemberPrimary);
                        $scope.isEditing = true;
                    };

                    $scope.revertInfo = function () {
                        $scope.contactInfo = $scope.originalContactInfo;
                        $scope.activeLocations = $scope.originalLocations;
                        $scope.isEditing = false;
                        $scope.isLoading = false;
                    };

                    $scope.editProfileImage = function (selectedFiles) {
                        if (!$scope.isUploading && selectedFiles.length > 0 && selectedFiles[0]) {

                            var opt = {};
                            opt['file'] = selectedFiles[0];
                            opt['updateCoordsOnClose'] = true;
                            opt['croppingModalCallBack'] = function (coords, image) {

                                // Change Blob to look like a file
                                image.name = selectedFiles[0].name;
                                image.lastModifiedDate = selectedFiles[0].lastModifiedDate;

                                coords.file = image;
                                $scope.isUploading = true;
                                $scope.uploadProgress = 0;

                                Upload.upload({
                                    url: publicConfiguration.TeamServerBaseURL + 'brands/' + $scope.brandId + '/users/' + $scope.member.id + '/profile_photo',
                                    withCredentials: true,
                                    headers: {},
                                    method: "PUT",
                                    data: coords
                                }).progress(function (evt) {
                                    var uploaded = evt.loaded || 0;
                                    var total = evt.total;

                                    $scope.uploadProgress = 100 * uploaded / total;

                                }).success(function (data, status, headers, config) {
                                    delete $scope.isUploading;
                                    $scope.member['profile_image'] = $scope.member['profile_image'] || {};
                                    $scope.member['profile_image']['uuid'] = data.data.uuid;

                                    setTimeout(function () {
                                        TSUsersService.updateUserInfo($scope.member.id, {
                                            profile_image: $scope.member['profile_image']
                                        });
                                    }, 500);

                                }).error(function (error) {
                                    delete $scope.isUploading;
                                    $scope.error = error;
                                });

                            };

                            // send selected files && show modal
                            $rootScope.$broadcast('showImageCroppingModal', opt);
                        }
                        else {
                            console.warn("Cropping tool called without a file selected");
                        }
                    };
                }
            };
        }]);
})(TeamAPI);
